<div class="nav-alert clearfix">
  <!-- <div class="nav-alert--exclamation">
    <i class="fas fa-exclamation"></i>
  </div> -->
  <!--<p>{{"NavMenu.Alert" | translate}}</p>-->
  <p>{{'Alert.Relieffor'|translate}}</p>
  <div class="nav-alert--button">
    <p *ngIf="!toggler" (click)="toggler = !toggler; toggleShowDiv('divA')">{{"NavMenu.Show" | translate}}</p>
    <p *ngIf="toggler" (click)="toggler = !toggler; toggleShowDiv('divA')">{{"NavMenu.Hide" | translate}}</p>
  </div>
  <!-- <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=SHJZBzjqG0WKvqY47dusgZ0k5CTcHDNJvR5V--t1mNlUMFI3TlVIUkdYVlFPNVJTQlVZRklNRTFEOS4u" target="_blank" style="margin-left: auto; color: #fff">Feedback</a> -->
</div>

<div  class="alert-message" [@slideInOut]="animationState" >


  <div  class="alert-message--exclamation">
    <!--<i class="fas fa-exclamation"></i>-->
    <i class="fa-solid fa-fire-flame-curved"></i>
    <!-- <i class="fas fa-file-alt"></i> -->
  </div>


  <div  class="alert-message--content">
    <!--<h5>{{'Alert.Public'|translate}}</h5>-->
    <!--<p [innerHTML]="'Alert.Propertytaxpayments2'|translate"></p>-->

    <p [innerHTML]="'Alert.Misfortue&Calamityv3'|translate"></p>
    <hr>

  </div>


</div>

<!-- <div  class="alert-message" [@slideInOut]="animationState" >


  <div  class="alert-message--exclamation"> -->
    <!--<i class="fas fa-exclamation"></i>-->
    <!-- <i class="fas fa-building"></i> -->
    <!-- <i class="fas fa-file-alt"></i> -->
  <!-- </div>


  <div  class="alert-message--content"> -->
    <!--<h5>{{'Alert.Public'|translate}}</h5>-->
    <!--<p [innerHTML]="'Alert.Propertytaxpayments2'|translate"></p>-->

    <!-- <strong [innerHTML]="'Alert.Toensure'|translate"></strong>
    <hr>

  </div>


</div> -->


<!-- <div  class="alert-message" [@slideInOut]="animationState" >


  <div  class="alert-message--exclamation"> -->
    <!--<i class="fas fa-exclamation"></i>-->
    <!-- <i class="fas fa-building"></i> -->
    <!-- <i class="fas fa-file-alt"></i> -->
  <!-- </div> -->


  <!-- <div  class="alert-message--content"> -->
    <!--<h5>{{'Alert.Public'|translate}}</h5>-->
    <!--<p [innerHTML]="'Alert.Propertytaxpayments2'|translate"></p>-->

    <!-- <strong [innerHTML]="'Alert.AllOffices1/8/25'|translate"></strong>
    <hr>

  </div>


</div> -->


<!-- <div style="position: relative;">


  <div class="alert-message" [@slideInOut]="animationState" >

    <div  class="alert-message--exclamation"> -->
      <!-- <i class="fas fa-exclamation"></i> -->
      <!-- <i class="fa-solid fa-computer"></i> -->
      <!-- <i class="fas fa-building"></i> -->


    <!-- </div>

    <div  class="alert-message--content">
      <p [innerHTML]="'Alert.DVXNoticeBody'|translate"></p>
      <hr>

    </div> -->




    <!-- <div style = "margin-top:20px;" class="alert-message--content">
      <p [innerHTML]="'Alert.Wearepleased'|translate"></p>
      <p>West Regional Office<br>
      6167 Bristol Parkway, Suite 100<br>
      Culver City, CA 90230</p>
      <p [innerHTML]="'Alert.Ournewoffice'|translate"></p>
      <p [innerHTML]="'Alert.Viewalloffice'|translate"></p>
      <hr>
      </div> -->
    <!-- <div style = "margin-top:20px;" class="alert-message--content">
      <p [innerHTML]="'Alert.LargeCrowds'|translate"></p>

      <p [innerHTML]="'Alert.WeApologize'|translate"></p>
      <hr>
    </div> -->

  <!-- </div> -->

  <!-- <div  class="alert-message" [@slideInOut]="animationState" >


    <div  class="alert-message--exclamation"> -->
      <!--<i class="fas fa-exclamation"></i>-->
      <!-- <i class="fas fa-building"></i> -->
      <!-- <i class="fas fa-file-alt"></i>
    </div>


    <div  class="alert-message--content"> -->
      <!--<h5>{{'Alert.Public'|translate}}</h5>-->
      <!--<p [innerHTML]="'Alert.Propertytaxpayments2'|translate"></p>-->

      <!-- <p [innerHTML]="'Alert.Prop5819_body'|translate"></p>


    </div>


  </div> -->


<!-- </div> -->